import { Pipe, PipeTransform } from '@angular/core';
import { MaterialCategoryDTO } from '@scip/api';

@Pipe({
  name: 'materialCategoryChip'
})
export class MaterialCategoryChipPipe implements PipeTransform {
  transform(value: MaterialCategoryDTO, isTooltip: boolean = false): string {
    if (!value || !value.additionalText) {
      return '';
    }
    if (isTooltip) {
      return value.identifier + ': ' + value.additionalText;
    } else {
      return value.additionalText;
    }
  }
}
